<template>
  <div class="box4">
    <pageTitle
      title="牛师带队&nbsp;&nbsp;高质量教研看师资"
      text="全球开源项目贡献&大厂企业级背景出身&专职教研团队"
    />

    <div class="top-box">
      <div class="block">
        <p>高投入</p>
        <span></span>
        亿元级研发投入<br />技术前沿
      </div>
      <div class="block">
        <p>强质量</p>
        <span></span> 严控教学质量<br />优中选优
      </div>
      <div class="block">
        <p>严考核</p>
        <span></span> 学员满意度打分<br />保障质量
      </div>
    </div>

    <div class="teacher-box">
      <div
        class="teacher"
        v-for="(item, index) in list"
        :key="index"
        :style="
          `backgroundImage: url(` +
          require(`../../../assets/coursePage/web/box4/${index + 1}.png`) +
          `)`
        "
        @click="changeCur(index)"
      >
        <div class="tName">{{ item.name }}老师</div>
        <p v-html="item.p"></p>
      </div>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      round
      :style="{ height: '5.333333rem' }"
    >
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ list[this.cur].name }}老师</div>

          <div class="close" @click="show = false"></div>
        </div>

        <p v-html="list[this.cur].info"></p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      list: [
        {
          name: "Pink",
          info: "B站粉丝47万+，视频播放量2000万+，抖音粉丝10万+。参与国家开放大学Module教育平台、环球影视（中国）等多个大型项目。<br/>拥有丰富前端教学经验，擅长课程设计，让学生学得开心，听得懂。",
          p: "“Pink，拼死也要克服前端” 10年+研发教学经验，B站知名UP主",
        },
        {
          name: "周",
          info: "曾担任系统架构师、前端主管。主导官方 Vue3迁移指南中文文档工作。主导研发物联网、网银、团购、电商、金融等多领域项目。<br/>研发交付 Vue3 小兔鲜电商、Vue3+TS 优医问诊等企业级闭环开发项目。",
          p: "深入研究Vue React；全球<br/>流行开源项目 vuejs 开源贡<br/>献者",
        },
        {
          name: "赵",
          info: "多年开发经验，精通HTML5、CSS3、JavaScript、jQuery、Vue、React等前端技术，曾先后主导多个大型项目开发。授课认真负责、深入浅出，致力于让不同基础的学生日有所学、日有所长。",
          p: "曾任华为高级前端开发工程师，精通H5游戏开发",
        },
        {
          name: "高",
          info: "负责平台级应用开发工具设计和架构。研发Vue2人力资源项目、升级版 Vue3 人力资源项目。<br/>擅长将学员与企业开发相结合，助力学员掌握核心技术和高薪就业。",
          p: "8年团队研发经验精通<br/>OTO 类移动开发业务",
        },
        {
          name: "蒋",
          info: "Web前端工程师，多年前端开发和实践教学经验，精通JavaScript、Ajax、jQuery、Vue、React、小程序以及Node.js、PHP、MySQL等前后端技术。喜欢钻研，热爱源码封装，授课风趣幽默，由浅入深，广为好评！",
          p: "精通Vue、React、TypeScript，多年前端开发和实践教学经验",
        },
        {
          name: "胡",
          info: "主导多个跨平台企业应用的研发工作。研发Vue快速入门课程，迭代 AJAX、Node、数据可视化阶段课程。<br/>善于将知识点结合实际业务讲解，让学员更好的学以致用，举一反三。",
          p: "8年团队研发+教学经验；<br/>精通 CMS 类开发业务",
        },
      ],
    };
  },
  methods: {
    changeCur(index) {
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box4 {
  padding: 80px 0;
  padding-bottom: 58px;
  width: 100%;
  background: url("../../../assets/coursePage/web/box4/bgc.png") no-repeat;
  background-size: cover;

  .top-box {
    display: flex;
    justify-content: space-evenly;
    margin: 0 auto;
    margin-top: 48px;
    margin-bottom: 48px;
    padding-top: 24px;
    width: 686px;
    height: 168px;
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0px 8px 24px 0px rgba(12, 158, 123, 0.08);
    border-radius: 16px;

    box-sizing: border-box;

    .block {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 36px;
      text-align: center;
      position: relative;
    }

    p {
      margin-bottom: 8px;
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #00b589;
      line-height: 44px;
      transform-style: preserve-3d;
      display: table;
      margin: 0 auto 8px;
    }
    p {
      position: relative;
      z-index: 10;
    }
    span {
      width: 84px;
      left: 50%;
      transform: translateX(-50%);
      height: 12px;
      background: #d4f7ef;
      position: absolute;
      display: block;
      top: 28px;

      z-index: 1;
    }
  }

  .teacher-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 654px;

    .teacher {
      margin-bottom: 32px;
      padding: 0 6px 0 24px;
      width: 310px;
      height: 390px;
      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      color: #fff;
      .tName {
        margin-top: 254px;
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      p {
        margin-top: 4px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
      }
    }
    .teacher:nth-child(3),
    .teacher:nth-child(4),
    .teacher:nth-child(6) {
      .tName {
        margin-top: 266px;
      }
    }
    .teacher:nth-child(5) {
      p{
        padding-right: 20px;
      }
    }
  }

  .pop {
    padding: 48px;
    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 32px;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }
    p {
      position: relative;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }
}
</style>
